(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/regenerator");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/promise");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/typeof");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/asyncToGenerator");

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._test = undefined;

var _regenerator = __webpack_require__(1);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = __webpack_require__(6);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(2);

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = __webpack_require__(0);

var _schema = __webpack_require__(7);

var _storage = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var demandJson = function demandJson(req) {
  if (!(req.headers['content-type'] || '').match('^application/json;?')) {
    return {
      status: 400,
      errors: ['Content-Type must be application/json']
    };
  }
};

// export a function that returns a function (because javascript)

exports.default = function (opts) {
  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(ctx) {
      var req, res, schema, limit, schemaReferences, table, plural, singular, idDelimiter, cors, log, result, abandon, id, getEntity, notFound, verb, _result, from, errors, order, filter, entity, _errors, entityOrPatch, originalEntity, updatedEntity, getRes, _errors2;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              // --- meta setup

              req = ctx.req;

              if (req) {
                _context.next = 3;
                break;
              }

              throw '\'req\' not in context - have you configured function.json?';

            case 3:

              // simplified response object, transformed at the bottom of this function
              res = void 0;

              if (opts.schema) {
                _context.next = 6;
                break;
              }

              throw 'no schema specified';

            case 6:
              schema = opts.schema;
              limit = opts.limit;

              // aggregate referenced types

              schemaReferences = [];

              (0, _lodash.forOwn)(schema, function (attr, name) {
                var ref = attr.references;
                // dedupe
                if (ref && schemaReferences.indexOf(ref) === -1) schemaReferences.push(attr.references);
              });

              table = opts.table;

              if (table) {
                _context.next = 13;
                break;
              }

              throw 'no table specified';

            case 13:
              if (!(!opts.name && !opts.plural)) {
                _context.next = 15;
                break;
              }

              throw 'no name/plural specified';

            case 15:
              plural = opts.plural || opts.name;
              singular = opts.singular || plural.substring(0, plural.length - 1);
              idDelimiter = opts.oneToManyIdDelimiter || ',';

              cors = function () {
                if (opts.cors) {
                  if (opts.cors === true) return true;
                  if ((0, _typeof3.default)(opts.cors) !== 'object') return [opts.cors];else return opts.cors;
                }
                return null;
              }();

              log = function log(s) {
                return !opts.silent && ctx.log(s);
              };

              // --- request setup

              log(req);

              // before we extract anything from req, call pre-hook:

              if (!opts.pre) {
                _context.next = 33;
                break;
              }

              result = opts.pre(ctx);
              abandon = void 0;

              // cancel everything else if it returns/resolves truthy

              if (!(result instanceof _promise2.default)) {
                _context.next = 30;
                break;
              }

              _context.next = 27;
              return result;

            case 27:
              abandon = _context.sent;
              _context.next = 31;
              break;

            case 30:
              abandon = result;

            case 31:
              if (!abandon) {
                _context.next = 33;
                break;
              }

              return _context.abrupt('return');

            case 33:
              id = req.params.id; // (optional)

              (0, _schema.schemaSetup)(schema, idDelimiter, opts.blobContainer);
              // plural is used as partition
              (0, _storage.storageSetup)(table, plural, schema, limit, opts.storageConnectionString, opts.blobContainer);

              // --- helpers involving ctx

              getEntity = function getEntity() {
                return req.body ? (0, _lodash.cloneDeep)(req.body) : {};
              };

              notFound = {
                status: 404,
                errors: ['not found']

                // --- process request

              };
              verb = req.method;

              // override this method?

              if (!(opts.override && opts.override[verb])) {
                _context.next = 50;
                break;
              }

              _result = opts.override[verb](ctx);

              if (!(_result instanceof _promise2.default)) {
                _context.next = 47;
                break;
              }

              _context.next = 44;
              return _result;

            case 44:
              res = _context.sent;
              _context.next = 48;
              break;

            case 47:
              res = _result;

            case 48:
              _context.next = 147;
              break;

            case 50:
              _context.t0 = verb;
              _context.next = _context.t0 === 'GET' ? 53 : _context.t0 === 'POST' ? 70 : _context.t0 === 'PUT' ? 96 : _context.t0 === 'PATCH' ? 96 : _context.t0 === 'DELETE' ? 139 : 146;
              break;

            case 53:
              if (!(0, _lodash.isUndefined)(id)) {
                _context.next = 66;
                break;
              }

              from = String(req.query.from);
              errors = [];

              order = function () {
                if (!req.query.order) return null;
                var o = req.query.order.split(',');
                o.forEach(function (attr) {
                  // can prepend attr with ! to sort descending
                  if (!schema[attr.replace(/^!/, '')]) errors.push('can\'t order by ' + attr);
                });
                return o;
              }();

              filter = function () {
                try {
                  if (!req.query.filter) return null;
                  return JSON.parse(req.query.filter);
                } catch (e) {
                  if (e instanceof SyntaxError) errors.push('invalid json for filter');else throw e;
                }
              }();

              if (!errors.length) {
                _context.next = 61;
                break;
              }

              // don't bother getting any data
              res = { status: 400, errors: errors };
              return _context.abrupt('break', 147);

            case 61:
              _context.next = 63;
              return (0, _storage.getAll)(from, order, filter);

            case 63:
              res = _context.sent;
              _context.next = 69;
              break;

            case 66:
              _context.next = 68;
              return (0, _storage.getOne)(id);

            case 68:
              res = _context.sent;

            case 69:
              return _context.abrupt('break', 147);

            case 70:
              res = demandJson(req);

              if (!res) {
                _context.next = 73;
                break;
              }

              return _context.abrupt('break', 147);

            case 73:
              if ((0, _lodash.isUndefined)(id)) {
                _context.next = 76;
                break;
              }

              res = notFound;
              return _context.abrupt('break', 147);

            case 76:

              (0, _schema.normalise)();
              entity = getEntity();

              (0, _schema.coerce)(entity, true);
              _errors = (0, _schema.validate)(entity);

              if (!_errors.length) {
                _context.next = 83;
                break;
              }

              res = { status: 422, errors: _errors };
              return _context.abrupt('break', 147);

            case 83:
              _context.prev = 83;
              _context.next = 86;
              return (0, _storage.uploadBlobs)(entity);

            case 86:
              _context.next = 92;
              break;

            case 88:
              _context.prev = 88;
              _context.t1 = _context['catch'](83);

              res = _context.t1;
              return _context.abrupt('break', 147);

            case 92:
              _context.next = 94;
              return (0, _storage.addOne)(entity);

            case 94:
              res = _context.sent;
              return _context.abrupt('break', 147);

            case 96:
              res = demandJson(req);

              if (!res) {
                _context.next = 99;
                break;
              }

              return _context.abrupt('break', 147);

            case 99:
              if (!(0, _lodash.isUndefined)(id)) {
                _context.next = 102;
                break;
              }

              res = notFound;
              return _context.abrupt('break', 147);

            case 102:

              (0, _schema.normalise)();
              entityOrPatch = getEntity();

              if (!entityOrPatch.id) {
                _context.next = 107;
                break;
              }

              res = {
                status: 422,
                errors: ['id update not allowed']
              };
              return _context.abrupt('break', 147);

            case 107:
              originalEntity = void 0, updatedEntity = void 0;

              if (!(verb === 'PATCH')) {
                _context.next = 119;
                break;
              }

              _context.next = 111;
              return (0, _storage.getOne)(id);

            case 111:
              getRes = _context.sent;

              if (!getRes.errors) {
                _context.next = 115;
                break;
              }

              res = getRes;
              return _context.abrupt('break', 147);

            case 115:

              // we never do partial updates as this could introduce race
              // conditions for schema validation
              originalEntity = getRes.results;
              updatedEntity = (0, _assign2.default)((0, _lodash.cloneDeep)(originalEntity), entityOrPatch);
              _context.next = 120;
              break;

            case 119:
              // verb === 'PUT'
              updatedEntity = entityOrPatch;

            case 120:
              delete updatedEntity.id;

              (0, _schema.coerce)(updatedEntity, false);
              _errors2 = (0, _schema.validate)(updatedEntity);

              if (!_errors2.length) {
                _context.next = 126;
                break;
              }

              res = { status: 422, errors: _errors2 };
              return _context.abrupt('break', 147);

            case 126:
              _context.prev = 126;
              _context.next = 129;
              return (0, _storage.uploadBlobs)(updatedEntity, originalEntity);

            case 129:
              _context.next = 135;
              break;

            case 131:
              _context.prev = 131;
              _context.t2 = _context['catch'](126);

              res = _context.t2;
              return _context.abrupt('break', 147);

            case 135:
              _context.next = 137;
              return (0, _storage.updateOne)(id, updatedEntity);

            case 137:
              res = _context.sent;
              return _context.abrupt('break', 147);

            case 139:
              if (!(0, _lodash.isUndefined)(id)) {
                _context.next = 142;
                break;
              }

              res = notFound;
              return _context.abrupt('break', 147);

            case 142:
              _context.next = 144;
              return (0, _storage.deleteOne)(id);

            case 144:
              res = _context.sent;
              return _context.abrupt('break', 147);

            case 146:
              throw 'allowed (but unsupported) http verb invoked';

            case 147:

              // override handlers can explicitly set res to null to prevent aftr's
              // 'post-processing':
              if (res !== null) {

                // default to a blank 200
                if (!res) res = {};

                // decide what ctx.res.body should actually hold, and end the request

                if (cors === true || Array.isArray(cors) && cors.indexOf(req.headers.origin) !== -1) ctx.res.headers['Access-Control-Allow-Origin'] = '*';

                if (res.errors) ctx.res.body = { errors: res.errors };else if (res.results) ctx.res.body = res.results;else {
                  // send a 'no content'
                  ctx.res.status = 204;
                  ctx.res.body = '';
                }

                if (res.status) ctx.res.status = res.status;
              }

              // responsibility of calling ctx.done() is passed to post() (if set):
              if (opts.post) opts.post(ctx);else ctx.done();

            case 149:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[83, 88], [126, 131]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var _test = exports._test = {
  demandJson: demandJson
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/object/assign");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.coerce = exports.normalise = exports.schemaSetup = exports._test = undefined;

var _typeof2 = __webpack_require__(3);

var _typeof3 = _interopRequireDefault(_typeof2);

var _lodash = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import { getOnePartitioned } from './storage'


var schema = void 0,
    idDelimiter = void 0,
    blobContainer = void 0;

// holds schema and idDelimiter after setting
var _test = exports._test = {};

var schemaSetup = exports.schemaSetup = function schemaSetup(_schema, _idDelimiter, _blobContainer) {
  schema = _schema;
  idDelimiter = _idDelimiter;
  blobContainer = _blobContainer;
  _test.schema = schema;
  _test.idDelimiter = idDelimiter;
  _test.blobContainer = blobContainer;
};

// makes the schema's attribute's options explicit (destructively)
var normalise = exports.normalise = function normalise() {
  var reservedNames = ['PartitionKey', 'RowKey', 'Timestamp', 'id', 'errors', '.metadata'];
  var validTypes = ['number', 'string', 'boolean'];

  var badSchema = function badSchema(s) {
    throw 'invalid schema: ' + s;
  };

  (0, _lodash.forOwn)(schema, function (attr, name) {
    // disallow reserved names
    if (reservedNames.indexOf(name) !== -1) badSchema('uses reserved name \'' + name + '\'');

    // coerce attribute to object; string-only implies type
    if ((0, _typeof3.default)(schema[name]) !== 'object') {
      schema[name] = { type: schema[name] };
      attr = schema[name];
    }

    // 'references' implies a string type
    if (attr.references) {
      attr.type = attr.type || 'string';

      if (!(0, _lodash.isUndefined)(attr.many)) {
        if (typeof attr.many !== 'boolean') {
          if (typeof attr.many !== 'number') badSchema('references-many type not a boolean or number');
          if (attr.many < 2) badSchema('references-many must be at least 2');
          if (attr.many !== Math.floor(attr.many)) badSchema('references-many must be an integer');
        }
      }
    } else if (!(0, _lodash.isUndefined)(attr.many)) badSchema('references-many only applies to references');

    if (attr.blobStorage) {
      attr.type = 'string';
      if (attr.references) badSchema('references can\'t be of a blobStorage type');
      if (!blobContainer) badSchema('blobStorage field specified without setting blobContainer');
    }

    // we must have a type by this point
    if (!attr.type) badSchema('no type specified for ' + name);
    if (!validTypes.includes(attr.type)) badSchema('invalid type for ' + name + ': ' + attr.type);

    // coerce 'optional' to boolean
    attr.optional = !!attr.optional;

    // if step is specified, make sure it's a positive number
    if (!(0, _lodash.isUndefined)(attr.step)) {
      if (attr.type !== 'number') badSchema('step specified for non-numeric attribute \'' + name + '\'');
      if (typeof attr.step !== 'number' || attr.step <= 0) badSchema('step for ' + name + ' must be a positive number');
    }
  });
};

// ensures an entity's references to other entities exist
var checkReferences = function checkReferences(errors, attr, objAttr, name) {
  if (!attr.references) return;
  // we've already dealt with null-ness at this point
  if (!objAttr) return;

  var ids = objAttr.split(idDelimiter);
  if (typeof attr.many === 'number') {
    if (ids.length > attr.many) errors.push('too many ids given for \'' + name + '\' (saw ' + ids.length + ', max ' + attr.many);
  } else if (attr.many !== true && ids.length > 1) errors.push('multiple ids specified for single-id reference ' + name);

  if ((0, _lodash.uniq)(ids).length !== ids.length) errors.push('duplicate ids given for \'' + name + '\'');

  // TODO: make sure all ids exist. this will require making the entire thing async.
  // const promises = []
  // ids.forEach((id) => {
  //   const promise = new Promise((resolve) => {
  //     getOnePartitioned(attr.references, id, (qRes) => {
  //       if(qRes.errors)
  //         errors.push(`referenced id '${name}' on '${attr.references}' doesn't exist: ${id}`)
  //       resolve()
  //     })
  //   })
  //   promises.push(promise)
  // })
  // return Promise.all(promises)
};

// deal with defaults, nulls, numbers to be rounded etc.
var coerce = exports.coerce = function coerce(entity, creating) {
  // schema must be normalised by this point

  var entityOriginal = (0, _lodash.cloneDeep)(entity);
  var deleteAttrs = [];

  (0, _lodash.forOwn)(schema, function (attr, name) {
    // would do the below, but need consistent r/w access:
    //const entityAttr = entity[name]

    var setDefault = function setDefault() {
      entity[name] = typeof attr.default === 'function' ? attr.default(entityOriginal, creating) : attr.default;
    };

    // if this field is passed in null or an empty string, either delete or default it
    if (entity[name] === null || entity[name] === '') {
      if (!attr.optional && !(0, _lodash.isUndefined)(attr.default)) setDefault();else {
        // validate() deals with requests attempting to unset required
        // fields; just delete it from the object for now
        deleteAttrs.push(name);
        return;
      }
    }

    // also default the field if it's required but completely unspecified
    if (!attr.optional && (0, _lodash.isUndefined)(entity[name])) setDefault();

    // if the field is now set, perform further coercions
    if (!(0, _lodash.isUndefined)(entity[name])) {
      // if step is specified, round numbers to it
      if (typeof entity[name] === 'number' && !(0, _lodash.isUndefined)(attr.step)) {
        entity[name] = Math.round(entity[name] / attr.step) * attr.step;
      }
    }
  });

  deleteAttrs.forEach(function (name) {
    return delete entity[name];
  });
};

// validates an entity against the schema
var validate = exports.validate = function validate(obj) {
  var errors = [];

  // schema must be normalised by this point
  (0, _lodash.forOwn)(schema, function (attr, name) {
    var objAttr = obj[name];

    // presence
    if (!attr.optional && (0, _lodash.isUndefined)(objAttr)) {
      errors.push('required \'' + name + '\' not specified');
      return;
    }

    // type
    if (!(0, _lodash.isUndefined)(objAttr)) {
      var actualType = typeof objAttr === 'undefined' ? 'undefined' : (0, _typeof3.default)(objAttr);
      if (attr.type !== actualType) {
        errors.push('incorrect type for \'' + name + '\': expected ' + attr.type + ' but got ' + actualType);
        return;
      }

      // number
      if (actualType === 'number') {
        if (attr.min && objAttr < attr.min) errors.push('\'' + name + '\': ' + objAttr + ' below minimum value of ' + attr.min);else if (attr.max && objAttr > attr.max) errors.push('\'' + name + '\': ' + objAttr + ' above maximum value of ' + attr.max);
      } else if (actualType === 'string') {
        if (attr.min && objAttr.length < attr.min) errors.push('\'' + name + '\': ' + objAttr + ' below minimum value of ' + attr.min);else if (attr.max && objAttr.length > attr.max) errors.push('\'' + name + '\': ' + objAttr + ' above maximum value of ' + attr.max);
      }
    }

    // references
    checkReferences(errors, attr, objAttr, name);

    // custom
    if (attr.validate) {
      try {
        if (!attr.validate(objAttr))
          // if falsy, use a general message
          throw 'validation failed';
      } catch (e) {
        errors.push(e.message);
      }
    }
  });

  // check all attributes on the entity are specified in the schema
  (0, _lodash.forOwn)(obj, function (attr, name) {
    if (!schema[name]) errors.push('\'' + name + '\' not an attribute');
  });

  return errors;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._test = exports.deleteOne = exports.updateOne = exports.addOne = exports.addOrReplace = exports.uploadBlobs = exports.getAll = exports.getOne = exports.getOnePartitioned = exports.storageSetup = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(1);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(4);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(2);

var _promise2 = _interopRequireDefault(_promise);

var _azureStorage = __webpack_require__(10);

var _azureStorage2 = _interopRequireDefault(_azureStorage);

var _v = __webpack_require__(11);

var _v2 = _interopRequireDefault(_v);

var _fileType = __webpack_require__(12);

var _fileType2 = _interopRequireDefault(_fileType);

var _lodash = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var svc = void 0,
    svcBlob = void 0,
    eg = void 0,
    table = void 0,
    partition = void 0,
    schema = void 0,
    limit = void 0,
    blobContainer = void 0;

// --- helpers

// get entities into a simpler internal format
var deazurify = function deazurify(entity) {
  // remove metadata and coerce any Int64s to JS numbers
  var cleaned = (0, _lodash.mapValues)(entity, function (v, name) {
    if ((schema[name] || {}).type === 'number') return Number(v._);
    return v._;
  });

  // reorganise properties
  delete cleaned.PartitionKey;
  delete cleaned.Timestamp;
  cleaned.id = cleaned.RowKey;
  delete cleaned.RowKey;
  delete cleaned['.metadata'];

  return cleaned;
};

// get entities into a suitable format for submission to the storage service
var azurify = function azurify(entity) {
  var azurified = {};

  (0, _lodash.forOwn)(schema, function (attr, name) {
    // nulls don't exist in table storage - so leave out of task
    if ((0, _lodash.isUndefined)(entity[name]) || entity[name] === null) return;

    // observe table storage type overrides
    var explicitType = attr.tableStorageType;
    if (explicitType) {
      azurified[name] = eg[explicitType](entity[name]);
      return;
    }

    switch (attr.type) {
      case 'string':
        azurified[name] = eg.String(entity[name]);
        break;

      case 'number':
        // craftily store as an int if step = 1
        if (attr.step === 1) azurified[name] = eg.Int64(entity[name]);else azurified[name] = eg.Double(entity[name]);
        break;

      case 'boolean':
        azurified[name] = eg.Boolean(entity[name]);
        break;

      default:
        throw 'er, either the schema is invalid or aftr is broken!?';
    }
  });

  return azurified;
};

// throw with a template
var serviceError = function serviceError(err) {
  throw 'table storage service error: ' + err;
};

// --- exports

var storageSetup = exports.storageSetup = function storageSetup(_table, _partition, _schema, _limit, connectionString, _blobContainer) {
  svc = _azureStorage2.default.createTableService(connectionString);
  svcBlob = _azureStorage2.default.createBlobService(connectionString);

  eg = _azureStorage2.default.TableUtilities.entityGenerator;

  table = _table;
  partition = _partition;
  schema = _schema;
  limit = _limit;
  blobContainer = _blobContainer;
};

var getOnePartitioned = exports.getOnePartitioned = function getOnePartitioned(_partition, rowKey) {
  return new _promise2.default(function (resolve) {
    svc.retrieveEntity(table, _partition, rowKey, function (err, result, qRes) {
      if (qRes.statusCode === 404) {
        resolve({ status: 404, errors: ['not found'] });
      } else {
        if (err) serviceError(err);
        resolve({ results: deazurify(result) });
      }
    });
  });
};

var getOne = exports.getOne = function getOne(rowKey) {
  return getOnePartitioned(partition, rowKey);
};

var getAll = exports.getAll = function getAll(from, order, filter) {
  var query = new _azureStorage2.default.TableQuery().where('PartitionKey eq ?', partition);

  return new _promise2.default(function (resolve) {
    svc.queryEntities(table, query, null, function (err, queryResult, response) {
      if (err) serviceError(err);

      var results = queryResult.entries;

      if (filter) {
        var fails = [];
        (0, _lodash.forOwn)(filter, function (constraint, attr) {
          if (!schema[attr]) return;

          results.forEach(function (r) {
            var v = r[attr] ? r[attr]._ : null;

            var no = function no(k) {
              return (0, _lodash.isUndefined)(k);
            };
            var pass = (no(constraint.eq) || v === constraint.eq) && (no(constraint.ne) || v !== constraint.ne) && (no(constraint.lt) || v < constraint.lt) && (no(constraint.gt) || v > constraint.gt) && (no(constraint.lte) || v <= constraint.lte) && (no(constraint.gte) || v >= constraint.gte);

            if (!pass) fails.push(r.RowKey._);
          });
        });

        results = results.filter(function (r) {
          return fails.indexOf(r.RowKey._) === -1;
        });
      }

      if (order) {
        results.sort(function (a, b) {
          var result = 0;

          order.forEach(function (attr) {
            if (result !== 0) return;

            var desc = attr[0] === '!';
            var actualAttr = attr.replace('!', '');

            var aAttr = (a[actualAttr] || {})._;
            var bAttr = (b[actualAttr] || {})._;

            // another hack for Int64 types
            if ((schema[actualAttr] || {}).type === 'number') {
              aAttr = Number(aAttr);
              bAttr = Number(bAttr);
            }

            if (aAttr === bAttr) return;
            if ((0, _lodash.isUndefined)(aAttr)) {
              result = desc ? 1 : -1;
              return;
            }
            if (aAttr < bAttr) result = desc ? 1 : -1;else result = desc ? -1 : 1;
          });

          return result;
        });
      }

      if (limit) {
        var sliced = false;
        for (var i = 0; i < results.length; i++) {
          var r = results[i];
          if (r.RowKey._ === from) {
            results = results.slice(i, i + limit);
            sliced = true;
            break;
          }
        }

        // if we can't find the 'from' id, slice from the beginning
        if (!sliced) results = results.slice(0, limit);
      }

      results = results.map(deazurify);
      resolve({ results: results });
    });
  });
};

var uploadBlobs = exports.uploadBlobs = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(entity) {
    var originalEntity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var toUpload, errors, name, attr, raw, ft, mime, whitelist, id, promises;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            toUpload = [];
            errors = [];

            // not using forOwn due to upcoming 'const mime = await ...'

            _context.t0 = _regenerator2.default.keys(entity);

          case 3:
            if ((_context.t1 = _context.t0()).done) {
              _context.next = 24;
              break;
            }

            name = _context.t1.value;

            if (entity.hasOwnProperty(name)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt('continue', 3);

          case 7:
            attr = entity[name];

            // ignore non-blob fields

            if (schema[name].blobStorage) {
              _context.next = 10;
              break;
            }

            return _context.abrupt('continue', 3);

          case 10:
            if (!(attr === originalEntity[name])) {
              _context.next = 12;
              break;
            }

            return _context.abrupt('continue', 3);

          case 12:

            // don't care if valid base64; will just be corrupt file otherwise.
            // (nb. mimeTypes might root out the problem)
            raw = Buffer.from(attr, 'base64');
            ft = (0, _fileType2.default)(raw);
            mime = ft ? ft.mime : 'application/octet-stream';
            whitelist = schema[name].mimeTypes;
            // for .includes below

            if (typeof whitelist === 'string') whitelist = [whitelist];

            if (whitelist && !whitelist.includes(mime)) errors.push('\'' + mime + '\' not an allowed MIME type for \'' + name + '\'');

            if (!errors.length) {
              _context.next = 20;
              break;
            }

            return _context.abrupt('continue', 3);

          case 20:

            // overwrite original id, if it's present as the original value
            id = originalEntity[name] || (0, _v2.default)();


            toUpload.push({ attrName: name, id: id, raw: raw, mime: mime });
            _context.next = 3;
            break;

          case 24:
            if (!errors.length) {
              _context.next = 26;
              break;
            }

            throw {
              status: 422,
              errors: errors
            };

          case 26:

            // don't upload in the same loop in order to collect mime errors
            promises = [];

            toUpload.forEach(function (upload) {
              promises.push(new _promise2.default(function (resolve, reject) {

                var options = { contentSettings: { contentType: upload.mime } };
                svcBlob.createBlockBlobFromText(blobContainer, upload.id, upload.raw, options, function (err, blob) {
                  if (err) {
                    // internal error - log, don't reveal to client
                    console.error(err);
                    reject({ status: 500 });
                  }

                  entity[upload.attrName] = upload.id;
                  resolve();
                });
              }));
            });

            if (!promises.length) {
              _context.next = 37;
              break;
            }

            _context.prev = 29;
            _context.next = 32;
            return _promise2.default.all(promises);

          case 32:
            _context.next = 37;
            break;

          case 34:
            _context.prev = 34;
            _context.t2 = _context['catch'](29);
            throw _context.t2;

          case 37:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[29, 34]]);
  }));

  return function uploadBlobs(_x) {
    return _ref.apply(this, arguments);
  };
}();

var addOrReplace = exports.addOrReplace = function addOrReplace(id, entity) {
  var replace = !!id;
  if (!id) id = (0, _v2.default)();

  var task = (0, _extends3.default)({
    PartitionKey: eg.String(partition),
    RowKey: eg.String(id)
  }, azurify(entity));

  return new _promise2.default(function (resolve) {
    var callback = function callback(err, qRes) {
      if (err) serviceError(err);
      var entityWithId = (0, _lodash.cloneDeep)(entity);
      entityWithId.id = id;
      resolve({
        status: replace ? 200 : 201,
        results: entityWithId
      });
    };

    if (!replace) svc.insertEntity(table, task, callback);else svc.replaceEntity(table, task, callback);
  });
};

var addOne = exports.addOne = function addOne(entity) {
  return addOrReplace(null, entity);
};

var updateOne = exports.updateOne = function updateOne(id, entity) {
  return addOrReplace(id, entity);
};

var deleteOne = exports.deleteOne = function deleteOne(id) {
  var task = {
    PartitionKey: { _: partition },
    RowKey: { _: id }
  };

  return new _promise2.default(function (resolve) {
    svc.deleteEntity(table, task, function (err, qRes) {
      if (qRes.statusCode === 404) {
        resolve({
          status: 404,
          errors: ['not found']
        });
      } else {
        if (err) serviceError(err);

        resolve();
      }
    });
  });
};

var _test = exports._test = {
  deazurify: deazurify,
  azurify: azurify,
  serviceError: serviceError
};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/extends");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("azure-storage");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("uuid/v4");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("file-type");

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// dist/aftr.js